export default function isInternetExplorer() {
  const ua = navigator.userAgent || navigator.vendor

  return "documentMode" in document || /Edge/.test(ua)
}
